import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

// Uncomment to package css transpiled from index.scss into index.css
//import './index.css';
import './shims/polyfills';

import TypeaheadApp from './Components/typeahead/TypeaheadApp';
import AddToWishlistApp from './Components/addtowishlist/AddToWishlistApp';
import quickOrderApp from './Components/quickorder';


if (typeof window === 'undefined')
    var window = {};

global.React          = React;
global.ReactDOM       = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Typeahead = TypeaheadApp;
global.AddToWishlist = AddToWishlistApp;
global.QuickOrder = quickOrderApp;